module.exports = __webpack_public_path__ + "img/industry.4f27f0e8.svg";